import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

export const getStepBaseModalLayoutStyles = () => ({
  stepModalHeader: {
    display: 'flex',
    paddingTop: '21px',
    justifyContent: 'space-between',
  },
  stepModalIndex: {
    marginLeft: 'auto',
    alignSelf: 'center',
    fontSize: '20px',
    color: palette.neutralPrimary,
  },
  stepModalContainer: {
    width: 632,
    height: 616,
    margin: '0 24px',
    position: 'relative',
  },
  stepModalContentContainer: {
    marginTop: '7px',
    '& .error': {
      fontSize: '12px',
      lineHeight: '16px',
      color: '#a80000',
    },
  },
  modalContainer: {
    display: 'flex',
  },
});

export const stepBaseModalStyles = {
  cancelButtonStyles: {
    root: {
      color: palette.neutralPrimary,
    },
    rootHovered: {
      color: palette.neutralDark,
    },
  },
};
